"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIntl = void 0;
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _useConfig = _interopRequireDefault(require("./useConfig"));
var _util = require("../components/Translated/util");
var _translations = require("../state/entities/translations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const fallbackIntlCache = (0, _reactIntl.createIntlCache)();
const FALLBACK_LOCALE = 'en-US';
const useIntl = () => {
  const {
    brandName,
    domain
  } = (0, _useConfig.default)();
  const {
    formatMessage,
    ...intl
  } = (0, _reactIntl.useIntl)();
  const translations = (0, _reactRedux.useSelector)(_translations.translationsSelectors.values);
  const fallbackIntl = (0, _reactIntl.createIntl)({
    locale: FALLBACK_LOCALE,
    messages: translations[FALLBACK_LOCALE]
  }, fallbackIntlCache);
  const formatMessageWithFallback = (messageDescriptor, values, opts) => {
    return formatMessage({
      ...messageDescriptor,
      defaultMessage: fallbackIntl.formatMessage(messageDescriptor, values)
    }, {
      ..._util.htmlTags,
      br: _util.br,
      brandName,
      domain,
      ...values
    }, opts);
  };
  const modifiedIntl = {
    ...intl,
    formatMessage: formatMessageWithFallback
  };
  return modifiedIntl;
};
exports.useIntl = useIntl;